<template>
  <div class="container">
    <!-- Section 1 -->
    <div class="row">
      <div class="col">
        <div class="jumbotron jumbotron-fluid" style="background-color: white">
          <!-- insert graphic here -->
          <img
            src="@/assets/logo.svg"
            style="width:15rem; height:15rem;"
            alt="sped graphic"
          />
          <br /><br />
          <h1 class="text-info">Special Data for Special Minds</h1>

          <p class="lead">
            Spend more time teaching and less time keeping data.
          </p>
          <br />
          <p class="lead">
            <button class="btn btn-primary btn-lg" v-on:click="$router.push({ name: 'v2SignIn' })" role="button">
              Sign up today!
            </button>
          </p>
          <br />
          <!-- insert down arrow graphic -->
          <img
            src="@/assets/DownArrows.svg"
            width="50"
            height="50"
            alt="arrow graphic"
          />
        </div>
      </div>
    </div>
    <!-- Section 2 -->
    <div style="margin-left:-15px; margin-right:-15px; margin-top:-30px;">
      <div class="p-3 mb-0 bg-info text-white"><h3>What We Offer</h3></div>
    </div>

    <div class="row bg-info">
      <div class="col">
        <img src="@/assets/GraphBars.svg" width="75" height="75" alt="icon" />
        <div class="p-3 mb-0 bg-info text-white">
          data graphing and progress report generator
        </div>
      </div>
      <div class="col">
        <img
          src="@/assets/FillableForms.svg"
          width="75"
          height="75"
          alt="icon"
        />
        <div class="p-3 mb-0 bg-info text-white">fillable forms</div>
      </div>
      <div class="col">
        <img
          src="@/assets/SchedulingCalendar.svg"
          width="75"
          height="75"
          alt="icon"
        />
        <div class="p-3 mb-0 bg-info text-white">
          i.e.p. scheduling and reminders
        </div>
      </div>
      <div class="col">
        <img src="@/assets/Star.svg" width="75" height="75" alt="icon" />
        <div class="p-3 mb-0 bg-info text-white">behavior tracking</div>
      </div>
      <div class="col">
        <img
          src="@/assets/EnvelopeParentInvolvement.svg"
          width="75"
          height="75"
          alt="icon"
        />
        <div class="p-3 mb-0 bg-info text-white">parent involvement</div>
      </div>
    </div>

    <!-- Section 3 -->
    <div class="row">
      <div class="col"><hr class="my-4" /></div>
    </div>
    <div class="row">
      <div class="col">
        <h3>Testimonials</h3>
        <br />
      </div>
    </div>
    <div class="row">
      <div class="card-deck">
        <div class="card pt-3">
          <img
            class="card-img-top"
            src="@/assets/GirlTestimonial.svg"
            width="75"
            height="75"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text">
              "I have been able to spend so much more time with my students!"
            </p>
          </div>
        </div>

        <div class="card pt-3">
          <img
            class="card-img-top"
            src="@/assets/BusinessTestimonial.svg"
            width="75"
            height="75"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text">
              "As a principal, I love being able to see all of the special
              education data in one place."
            </p>
          </div>
        </div>

        <div class="card pt-3">
          <img
            class="card-img-top"
            src="@/assets/CasualTestimonial.svg"
            width="75"
            height="75"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text">
              "This website is a game changer! I love the fillable forms for
              observations."
            </p>
          </div>
        </div>
      </div>
    </div>
    <img style="width: 0; height: 0;" src="../assets/logo.png" />
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      something: ""
    };
  },
  mounted() {},
  methods: {
    method() {}
  }
};
</script>

<style scoped>
.btn.btn-primary {
  background-color: #f0453c;
  color: white;
  border-color: #f0453c;
}
.display-4 {
  color: #41b8de;
}
</style>
